import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, IPeoplePickerItemSelectedProps, PeoplePickerItem, ValidationState, NormalPeoplePicker, IPersonaProps, IPickerItemProps, DatePicker, DayOfWeek, defaultDatePickerStrings, DialogFooter, CheckboxVisibility, TooltipHost, ConstrainMode } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks"
import { getPage } from "../../../../app/Pages"
import { setPage } from "../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../common/Table/Table"
import { reset, dismissMessage, setSort, setNumberOfResults, resetSet, setSelectedItems, setSearchText, setIsFilteredSet, addItem, updateItem, getItems, getClinetUsers, resetUsers, setIsFilteredOwnersSet, setFromFilterOption, setSelectedUserItems, setToFilterOption, setMessage, setSelectedFromAccountItems, setSelectedToAccountItems, setStatusFilterOption, setSelectedCurrencyItems, resetFromAccountsSet, setIsFilteredFromAccountSet, getFromAccounts, resetToAccountsSet, setIsFilteredToAccountSet, getToAccounts, resetCurrencies, setIsFilteredCurrenciesSet, getCurrencies, updateStatus, setSelectedCurrencyPairItems, resetCurrencyPairs, setIsFilteredCurrencyPairsSet, getCurrencyPairs } from "./TradesPageSlice"
import { ApiMessage, CLIENT_PROFILE_LOGO_URL, getHeaders, getSession } from "../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';
import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { getMainTheme } from "../../../../app/Themes"
import { SearchField } from "../../../common/SearchField/SearchField"
import { currencyFormatter, formatDate, printComponent, normalizeKey } from "../../../../app/Helpers"
import { TableState } from "../../../common/Table/TableSate"
import { Message } from "../../../common/Message/Message"
import { ShareBox } from "../../../common/ShareBox/ShareBox"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool, string } from "yup"
import { Popup } from "../../../common/Popup/Popup"
import { FormType } from "../../../forms/FormProps"
import { TreasuryStatus, LimitationType, Operations, Natures, OrderAction, OrderTransactionStatus } from "../../../../app/Enums"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import moment from "moment"
import { GetAccountsRequest } from "../../../../repository/Accountant/account_pb"
import { GetTreasuriesRequest, GetTreasuriesResponse } from "../../../../repository/Accountant/treasury_pb";
import { GetOrderTransactionsRequest, UpdateOrderTransactionStateRequest } from "../../../../repository/Trading/orderTransaction_pb"
import { GetUsersRequest } from "../../../../repository/UserManagement/Customers/user_pb"
import { useReactToPrint } from "react-to-print"
import { PageProps } from "../../PageProps"
import { List } from "../../../common/List/List"
import { UsersPage } from "../../Customers/Users/UsersPage"
import { GetCurrenciesRequest } from "../../../../repository/Accountant/currency_pb"
import { CurrenciesPage } from "../../Accountant/Currencies/CurrenciesPage"
import { AccountsPage } from "../../Accountant/Accounts/AccountsPage"
import { TradesForm } from "../../../forms/Trading/Trades/TradesForm"
import { DynamicField } from "../../../common/DynamicFields/DynamicFields"
import { TextView } from "../../../common/DataView/TextView"
import { GetCurrencyPairsRequest } from "../../../../repository/Trading/currency_pair_pb"
import { CurrencyPairsPage } from "../CurrencyPairs/CurrencyPairsPage"

const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};

let req: GetOrderTransactionsRequest;
let clintsReq: GetUsersRequest;
let org: number = -1;
let fromAccountsReq: GetAccountsRequest;
let toAccountsReq: GetAccountsRequest;
let currenciesReq: GetCurrenciesRequest;
let currecyPairsReq: GetCurrencyPairsRequest;

let getItemsPromise: any;
let getFilterPromise: any;
let actionPromise: any;

const key = "trading/trades"
export const TradesPage: React.FunctionComponent<PageProps> = (props) => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [tranStatus, setTranStatus] = useState<any>(undefined)
    const state: {
        isChangeStateLoading: boolean,
        set: TableState,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        searchText: string | undefined,
        fromFilterOption: { value: string, text: string }
        filters: any[],
        toFilterOption: { value: string, text: string }
        clients: TableState,
        statusFilterOption: { key: number, text: string }
        fromAccount: TableState,
        toAccount: TableState,
        currencies: TableState,

        currencyPairs: TableState,

    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.tradesPage.isChangeStateLoading,
            set: state.tradesPage.set,
            message: state.tradesPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            searchText: state.tradesPage.searchText,
            fromFilterOption: state.tradesPage.fromFilterOption,
            filters: state.tradesPage.filters,
            toFilterOption: state.tradesPage.toFilterOption,
            clients: state.tradesPage.clients,
            fromAccount: state.tradesPage.fromAccount,
            toAccount: state.tradesPage.toAccount,
            currencies: state.tradesPage.currencies,
            statusFilterOption: state.tradesPage.statusFilterOption,
            currencyPairs: state.tradesPage.currencyPairs,


        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const closeTreasuryActionConfirmationcalloutTargetId = useId('close-treasury-action-callout-target');
    const activityActionConfirmationcalloutTargetId = useId('activity-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)
    const ref = useRef<HTMLDivElement>(null);
    const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});

    const getActionId = (action: number): string => {
        if (action == 1) {
            return closeTreasuryActionConfirmationcalloutTargetId;
        } else if (action == 2) {
            return activityActionConfirmationcalloutTargetId;
        } else {
            return ""
        }
    }

    const _selection = useConst(() => new Selection({
        onSelectionChanged: () => {
            if (_selection.count > 0) {
                dispatch(setSelectedItems(_selection.getSelection()));
            } else {
                dispatch(setSelectedItems([]));
            }
        },

    }));

    const clearFilter = () => {
        dispatch(setSelectedFromAccountItems([]))
        req.setFromaccount(undefined)
        dispatch(setSelectedToAccountItems([]))
        req.setToaccount(undefined)
        dispatch(setStatusFilterOption({ key: 0, text: "" }))
        req.setStatus(undefined)
        dispatch(setFromFilterOption({ value: "", text: "" }))
        req.setFrom(undefined)
        dispatch(setToFilterOption({ value: "", text: "" }))
        req.setTo(undefined)
        dispatch(setSelectedCurrencyItems([]))
        req.setCurrency(undefined)
        dispatch(setSelectedCurrencyPairItems([]))
        req.setCurrencypair(undefined)
    }

    const search = (searchText: string | undefined) => {
        let isFiltered: boolean = false;
        if (searchText) {
            const wrapper = new StringValue();
            wrapper.setValue(searchText.trim());
            req.setSearch(wrapper)
            isFiltered = true;
        } else {
            req.setSearch(undefined)
        }
        if (state.currencyPairs.selected.length > 0) {
            const wrapper = new StringValue();
            wrapper.setValue((state.currencyPairs.selected.at(0)?.id));
            req.setCurrencypair(wrapper)
            isFiltered = true;
        } else {
            req.setCurrencypair(undefined)
        }
        if (state.clients.selected.length > 0) {
            const wrapper = new StringValue();
            wrapper.setValue((state.clients.selected.at(0)?.internalId));
            req.setClient(wrapper)
            isFiltered = true;
        } else {
            req.setClient(undefined)
        }

        if (state.fromAccount.selected.length > 0) {
            const wrapper = new StringValue();
            wrapper.setValue((state.fromAccount.selected.at(0)?.internalId));
            req.setFromaccount(wrapper)
            isFiltered = true;
        } else {
            req.setFromaccount(undefined)
        }

        if (state.toAccount.selected.length > 0) {
            const wrapper = new StringValue();
            wrapper.setValue((state.toAccount.selected.at(0)?.internalId));
            req.setToaccount(wrapper)

            isFiltered = true;
        } else {
            req.setToaccount(undefined)
        }

        if (state.currencies.selected.length > 0) {
            const wrapper = new StringValue();
            wrapper.setValue((state.currencies.selected.at(0)?.id));
            req.setCurrency(wrapper)

            isFiltered = true;
        } else {
            req.setCurrency(undefined)

        }

        if (state.statusFilterOption.key != 0) {
            const wrapper = new Int32Value();
            wrapper.setValue(state.statusFilterOption.key);
            req.setStatus(wrapper)
            isFiltered = true;

        } else {
            req.setStatus(undefined)
        }

        if (state.fromFilterOption && state.fromFilterOption.value.trim().length > 0) {
            const wrapper = new Timestamp();

            wrapper.fromDate(moment(state.fromFilterOption.value, 'YYYY-MM-DD').startOf('day').toDate())
            req.setFrom(wrapper)
            isFiltered = true;

        } else {
            req.setFrom(undefined)
        }

        if (state.toFilterOption && state.toFilterOption.value.trim().length > 0) {
            const wrapper = new Timestamp();
            wrapper.fromDate(moment(state.toFilterOption.value, 'YYYY-MM-DD').endOf('day').toDate())
            req.setTo(wrapper)
            isFiltered = true;

        } else {
            req.setTo(undefined)
        }

        req.setNextto(undefined)
        dispatch(resetSet())
        dispatch(setIsFilteredSet(isFiltered))
        getItemsPromise?.abort()
        getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))
    }


    useEffect(() => {
        if (props.maintainState && req && clintsReq && toAccountsReq && currenciesReq && fromAccountsReq && currecyPairsReq) {

        } else {

            req = new GetOrderTransactionsRequest();
            clintsReq = new GetUsersRequest();
            fromAccountsReq = new GetAccountsRequest();
            toAccountsReq = new GetAccountsRequest();
            currenciesReq = new GetCurrenciesRequest();
            currecyPairsReq = new GetCurrencyPairsRequest();

            var l = searchParams.get('org');
            if (l) {
                org = Number(l);
                if (Number.isNaN(org)) {
                    org = -1;
                } else {
                    const wrapper = new Int32Value();
                    wrapper.setValue(org);
                    req.setOrganization(wrapper)
                    clintsReq.setOrganization(wrapper)
                    fromAccountsReq.setOrganization(wrapper)
                    toAccountsReq.setOrganization(wrapper)
                    currenciesReq.setOrganization(wrapper)
                    currecyPairsReq.setOrganization(wrapper)

                }
            }
            if (!props.isSelection) {
                const page = getPage(key)
                dispatch(setTitle(t(normalizeKey(page?.title))));
                dispatch(setPage(page));
            }

            req.setNextto(undefined)
            req.setNumofresults(state.set.numberOfResults)
            req.setOrder(state.set.isDescending)

            const boolv = new BoolValue();
            boolv.setValue(true);

            currenciesReq.setNumofresults(state.currencies.numberOfResults)
            currenciesReq.setOrder(state.currencies.isDescending)
            //currenciesReq.setIsavailable(boolv)

            currecyPairsReq.setNumofresults(state.currencyPairs.numberOfResults)
            currecyPairsReq.setOrder(state.currencyPairs.isDescending)

            fromAccountsReq.setNumofresults(state.fromAccount.numberOfResults)
            fromAccountsReq.setOrder(state.fromAccount.isDescending)
            toAccountsReq.setNumofresults(state.toAccount.numberOfResults)
            toAccountsReq.setOrder(state.toAccount.isDescending)


            clintsReq.setNumofresults(state.clients.numberOfResults)
            clintsReq.setOrder(state.clients.isDescending)

            getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))
        }

        // dispatch(setMessage({ body: t("statementAccountDesc", { account: props.account?.name }), type: 4, title: "", data: 1 }))

        return () => { //clean up
            if (props.maintainState) {
                _selection.setAllSelected(false)
                return;
            }
            getItemsPromise?.abort();
            getFilterPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])
    /*
    
          public long Id { get; set; }
                public string InternalId { get; set; }
                public string Name { get; set; }
                public string Code { get; set; }
                public decimal MirrorBalance { get; set; }
                public CurrencyResponse Currency { get; set; }
                public int Status { get; set; }
                public AccountTypeResponse AccountType { get; set; }
                public OwnerResponse Owner { get; set; }
                public ProfileResponse CreatedBy { get; set; }
                public DateTime CreatedDate { get; set; }
    */

    const c: IColumn[] = [
        {
            key: 'id',
            name: t("id"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.id != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/orderTransactions/" + item?.id + ((org == -1) ? "" : "?org=" + org));
                        }
                    }
                    } href={"/orderTransactions/" + item?.id + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}> {item?.id}</Link >;
            },
        },

        {
            key: 'currencyPairId',
            name: t("pair"),
            minWidth: 50,
            maxWidth: 340,
            isRowHeader: true,
            isResizable: true,
            isMultiline: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.currencyPairId != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/currency-pairs/" + item?.currencyPairId + ((org == -1) ? "" : "?org=" + org));
                        }
                    }
                    } href={"/currency-pairs/" + item?.currencyPairId + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}><Persona
                            text={item?.currencyPairName}
                            secondaryText={(item?.currencyPairBaseCurrencyCode == "" ? item?.currencyPairBaseCurrencyId : item?.currencyPairBaseCurrencyCode) + "-" + (item?.currencyPairQuoteCurrencyCode == "" ? item?.currencyPairQuoteCurrencyId : item?.currencyPairQuoteCurrencyCode)}
                            imageInitials={item?.currencyPairBaseCurrencySymbol + "/" + item?.currencyPairQuoteCurrencySymbol}
                            size={PersonaSize.size40}

                        /></Link>;



                //return <Link href="/" underline >{item.name}</Link>;
            },
        },
        {
            key: 'currencyId',
            name: t("transactionTitle"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {

                if (item?.currencyId && item.currencyPairQuoteCurrencyId)
                    return <Text styles={{ root: { color: item?.currencyId == item?.currencyPairQuoteCurrencyId ? "#008000" : "#FF0000" } }} > {item?.currencyId == item?.currencyPairQuoteCurrencyId ? t("buy") : t("sell")} </Text>;
            },
        },


        {
            key: 'itemPrice',
            name: t("price"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.itemPrice != undefined)
                    return <Text>{currencyFormatter(item?.itemPrice, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;


            },
        },

        {
            key: 'itemQuantity',
            name: t("amount"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.itemPrice != undefined)
                    return <Text>{currencyFormatter(item?.itemQuantity, { significantDigits: item?.currencyPairBaseCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairBaseCurrencySymbol })}</Text>;



            },
        },

        {
            key: 'total',
            name: t("total"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.itemSubTotal != undefined)
                    return <Text>{currencyFormatter(item?.itemSubTotal, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;


            },
        },
        {
            key: 'statusId',
            name: t("status"),
            minWidth: 50,
            maxWidth: 100,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {

                if (item?.statusId != undefined)
                    return <TooltipHost
                        content={item?.statusCreatedBy + " @ " + item?.statusCreatedDate}
                    ><Text>{[{ key: OrderTransactionStatus.NEW, text: t("new") },
                    { key: OrderTransactionStatus.EXPIRED, text: t("expired") },
                    { key: OrderTransactionStatus.FAILED, text: t("failed") }, { key: OrderTransactionStatus.CANCELLED, text: t("cancelled") },
                    { key: OrderTransactionStatus.PENDING, text: t("pending") }, { key: OrderTransactionStatus.PROCESSING, text: t("processing") }
                        , { key: OrderTransactionStatus.REJECTED, text: t("rejected") }
                        , { key: OrderTransactionStatus.SETTLED, text: t("settled") }
                    ].filter(e => e.key == item?.statusId).at(0)?.text ?? t("new")}</Text></TooltipHost>;
                else
                    return <Text>{t("new")}</Text>;

            },
        },


        {
            key: 'buyOrder',
            name: t("buyOrder"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item, i, c) => {

                if (item?.id != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/orders/" + item?.buyOrder + ((org == -1) ? "" : "?org=" + org));
                            window.location.reload();
                        }
                    }
                    } href={"/orders/" + item?.buyOrder + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}> {item?.buyOrder}</Link >;
            },
        },
        {
            key: 'buyTransactionId',
            name: t("buyTransaction"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.id != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/account-transactions/" + item?.buyTransactionInternalId + ((org == -1) ? "" : "?org=" + org));
                        }
                    }
                    } href={"/account-transactions/" + item?.buyTransactionInternalId + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}> {item?.buyTransactionId}</Link >;
            },
        },
        {
            key: 'sellOrder',
            name: t("sellOrder"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item, i, c) => {

                if (item?.id != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/orders/" + item?.sellOrder + ((org == -1) ? "" : "?org=" + org));
                            window.location.reload();
                        }
                    }
                    } href={"/orders/" + item?.sellOrder + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}> {item?.sellOrder}</Link >;
            },
        },
        {
            key: 'sellTransactionId',
            name: t("sellTransaction"),
            minWidth: 50,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.id != undefined)
                    return <Link onClick={(e) => {
                        if (e && !props.isSelection) {
                            e.preventDefault();
                            navigate("/account-transactions/" + item?.sellTransactionInternalId + ((org == -1) ? "" : "?org=" + org));
                        }
                    }
                    } href={"/account-transactions/" + item?.sellTransactionInternalId + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}> {item?.sellTransactionId}</Link >;
            },
        },


        {
            key: 'clientName',
            name: t("client"),
            minWidth: 20,
            maxWidth: 200,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return <Link onClick={(e) => {
                    if (e && !props.isSelection) {
                        e.preventDefault();
                        navigate("/customers/users/" + item?.clientId + ((org == -1) ? "" : "?org=" + org));
                    }
                }
                } href={"/customers/users/" + item?.clientId + ((org == -1) ? "" : "?org=" + org)} target={props.isSelection ? "_blank" : undefined}><Persona
                        text={item?.clientName == "" ? item?.clientId : item?.clientName}
                        imageUrl={CLIENT_PROFILE_LOGO_URL + "/" + getSession()?.organization?.id + "/" + item?.clientId + "/profile.jpg"}

                        size={PersonaSize.size40}
                    /></Link>

            },
        },

        {
            key: 'extraInfo',
            name: t("info"),
            minWidth: 20,
            maxWidth: 150,
            isRowHeader: true,
            isResizable: true,
            isMultiline: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return item?.extraFields.map((e: DynamicField, index: number) => {
                    return <Stack key={e.key}>
                        <TextView label={e.label ?? ""} value={e?.value} />

                    </Stack>
                })
            },
        },

        {
            key: 'createdDate',
            name: t("date"),
            minWidth: 20,
            maxWidth: 150,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {

                return <Text>{(item?.createdDate)}</Text>; //{item.createdDate}
            },
        },



    ];

    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(108)
                }
            }
        },
        {
            key: 'status',
            text: t("updateOrderTranStatus"),
            iconProps: { id: activityActionConfirmationcalloutTargetId, iconName: "StatusCircleInner", styles: { root: { fontWeight: "bold" } } },
            title: t("updateOrderTranStatus"),
            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 2 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 2 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 2 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(2)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.set.selected.at(0)?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },

        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },


    ];
    const _selectionItemsNoStatus: ICommandBarItemProps[] = [
        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(108)
                }
            }
        },

        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.set.selected.at(0)?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },

        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },


    ];
    const mainOptions: ICommandBarItemProps[] = [

        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.set.isFetching,
            onClick: () => {
                dispatch(resetSet())
                req.setNextto(undefined)
                //   if (!state.searchText || state.searchText?.trim().length == 0) {
                //     req.setSearch(undefined)
                //}
                getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))
            }
        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];
    const _farOptions: ICommandBarItemProps[] = [
        {
            key: 'sort',
            text: t('sort'),
            title: t('sort'),
            iconProps: { iconName: 'sort' },
            disabled: state.set.isFetching,
            subMenuProps: {
                items: [{
                    key: 'ascending',
                    text: t('ascendingDate'),
                    title: t('ascendingDate'),
                    canCheck: true,
                    checked: !state.set.isDescending,
                    onClick: () => {
                        dispatch(setSort(false))
                        dispatch(resetSet())
                        req.setOrder(false)
                        req.setNextto(undefined)
                        getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))

                    }


                }, {
                    key: 'descending',
                    text: t('descendingDate'),
                    title: t('descendingDate'),
                    canCheck: true,
                    checked: state.set.isDescending,
                    onClick: () => {
                        dispatch(setSort(true))
                        dispatch(resetSet())
                        req.setOrder(true)
                        req.setNextto(undefined)
                        getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))

                    }

                }]
            }
        }


    ];
    const _farBottomOptions: ICommandBarItemProps[] = [
        {
            key: 'results',
            text: t('results') + ': ' + state.set.numberOfResults,
            title: t('results') + ': ' + state.set.numberOfResults,
            iconProps: { iconName: 'ShowResults' },
            subMenuProps: {
                items: [{
                    key: '10',
                    text: '10',
                    title: '10',
                    canCheck: true,
                    checked: (state.set.numberOfResults == 10 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(10))
                        req.setNumofresults(10)
                    }


                }, {
                    key: '50',
                    text: '50',
                    title: '50',
                    canCheck: true,
                    checked: (state.set.numberOfResults == 50 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(50))
                        req.setNumofresults(50)
                    }

                },
                {
                    key: '100',
                    text: '100',
                    title: '100',
                    canCheck: true,
                    checked: (state.set.numberOfResults == 100 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(100))
                        req.setNumofresults(100)
                    }

                }]
            }
        }
    ];




    const onFromAccountsFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {


        dispatch(resetFromAccountsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        fromAccountsReq.setSearch(wrapper)
        fromAccountsReq.setNextto(undefined)
        dispatch(setIsFilteredFromAccountSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getFromAccounts({ body: fromAccountsReq, headers: getHeaders() }))
        return [];

    }


    const onPairsFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCurrencyPairs())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        currecyPairsReq.setSearch(wrapper)
        currecyPairsReq.setNextto(undefined)
        dispatch(setIsFilteredCurrencyPairsSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
        return [];

    }



    const onToAccountsFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {


        dispatch(resetToAccountsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        toAccountsReq.setSearch(wrapper)
        toAccountsReq.setNextto(undefined)
        dispatch(setIsFilteredToAccountSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getToAccounts({ body: toAccountsReq, headers: getHeaders() }))
        return [];

    }





    const onCurrenciesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCurrencies())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        currenciesReq.setSearch(wrapper)
        currenciesReq.setNextto(undefined)
        dispatch(setIsFilteredCurrenciesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCurrencies({ body: currenciesReq, headers: getHeaders() }))
        return [];

    }

    const onOwnersFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {

        dispatch(resetUsers())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        clintsReq.setSearch(wrapper)
        clintsReq.setNextto(undefined)
        dispatch(setIsFilteredOwnersSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
        return [];

    }


    return (
        <Stack>


            <Popup isOpen={(currentAction == 1000)} title={t("clients")} onDismiss={() => { setCurrenctAction(0) }} >

                <UsersPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedUserItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 1003)} title={t("currencies")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrenciesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedCurrencyItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 108)} title={t("editTransaction")} onDismiss={() => { setCurrenctAction(0) }} >

                <TradesForm childrenGap={10} maxWidth={280} type={FormType.EDIT} fetchData={true} renderObject={state.set.selected.at(0)} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 1005)} title={t("accounts")} onDismiss={() => { setCurrenctAction(0) }} >
                <AccountsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedFromAccountItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 1004)} title={t("accounts")} onDismiss={() => { setCurrenctAction(0) }} >
                <AccountsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedToAccountItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 1006)} title={t("pair")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrencyPairsPage isSelection={true} onItemSelected={(e) => {

                    dispatch(setSelectedCurrencyPairItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }
            <CommandBar
                items={state.set.selected.length == 0 ? mainOptions : state.set.selected.at(0).statusId == undefined || state.set.selected.at(0).statusId == OrderTransactionStatus.PENDING ||
                    state.set.selected.at(0).statusId == OrderTransactionStatus.NEW || state.set.selected.at(0).statusId == OrderTransactionStatus.PROCESSING ? _selectionItems : _selectionItemsNoStatus}
                farItems={_farOptions}

            //id={actionConfirmationcalloutTargetId}


            />



            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareOrderTransaction")} value={`https://${window.location.host}/orderTransactions/${state.set.selected.at(0).id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}

            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 2 ? t("updateOrderTranStatus") : "")}
                        </Text>


                        <ComboBox
                            label={t("status")}
                            required
                            allowFreeform={true}
                            autoComplete={'on'}
                            disabled={state.isChangeStateLoading}
                            options={[
                                { key: OrderTransactionStatus.PENDING, text: t("pending") },
                                { key: OrderTransactionStatus.PROCESSING, text: t("processing") },

                                { key: OrderTransactionStatus.REJECTED, text: t("rejected") },
                                { key: OrderTransactionStatus.SETTLED, text: t("settled") },
                                { key: OrderTransactionStatus.EXPIRED, text: t("expired") },
                                { key: OrderTransactionStatus.FAILED, text: t("failed") },
                                { key: OrderTransactionStatus.CANCELLED, text: t("cancelled") }
                            ].filter(e => e.key != state.set.selected.at(0)?.statusId)}
                            selectedKey={tranStatus?.key}
                            onChange={(e, o) => {
                                setTranStatus({ key: o?.key, text: o?.text })
                            }} />


                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.set.selected.length > 0) {
                                        if (currentAction == 2) {
                                            if (tranStatus) {
                                                let req = new UpdateOrderTransactionStateRequest();
                                                req.setId(state.set.selected.at(0)?.id)

                                                req.setStatus(tranStatus.key)

                                                actionPromise?.abort();
                                                actionPromise = dispatch(updateStatus({ body: req, headers: getHeaders(), metadata: getSession() }))
                                                actionPromise.unwrap().then((e: any) => {
                                                  //  _selection.setAllSelected(false)
                                                    setTranStatus(undefined)
                                                })

                                            }

                                        }
                                    }
                                    setTranStatus(undefined)

                                }} text={(currentAction == 2 ? t("change") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}


            {isCalloutVisible ? (
                <Callout
                    ariaLabelledBy={labelId}

                    target={`#${calloutTargetId}`}
                    onDismiss={toggleIsCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    isBeakVisible={true}
                >
                    <Stack tokens={{ padding: 28, childrenGap: 30 }}  >
                        <Text block variant="mediumPlus" >
                            {t("filterDesc")}
                        </Text>
                        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 20 }} >
                            <Label>{t("status")}</Label>
                            <Dropdown
                                selectedKey={state.statusFilterOption.key}
                                options={[{ key: 0, text: t("all") }, { key: OrderTransactionStatus.NEW, text: t("new") },
                                { key: OrderTransactionStatus.EXPIRED, text: t("expired") },
                                { key: OrderTransactionStatus.FAILED, text: t("failed") }, { key: OrderTransactionStatus.CANCELLED, text: t("cancelled") },
                                { key: OrderTransactionStatus.PENDING, text: t("pending") }, { key: OrderTransactionStatus.PROCESSING, text: t("processing") }
                                    , { key: OrderTransactionStatus.REJECTED, text: t("rejected") }
                                    , { key: OrderTransactionStatus.SETTLED, text: t("settled") }
                                ]}
                                styles={{ root: { width: 300 } }}
                                onChange={((e: React.FormEvent<HTMLDivElement>, item?: IDropdownOption) => {

                                    dispatch(setStatusFilterOption({ key: Number(item?.key), text: t("status") + ":" + item?.text }))

                                })}

                            />
                        </Stack>
                        <Stack horizontalAlign="space-between" horizontal tokens={{ childrenGap: 20 }} >
                            <Label >{t("client")}</Label>
                            <List
                                isPeoplePicker={true}
                                suggestionsHeaderText={t('clients')}
                                styles={{ root: { width: 268 } }}
                                isLoading={state.clients.items.length == 0 ? state.clients.isFetching : false}
                                isSearching={state.clients.items.length > 0 ? state.clients.isFetching : false}
                                moreSuggestionsAvailable={state.clients.hasMore && !state.clients.isFetching}
                                suggestions={state.clients.items.length > 0 ? state.clients.items.map(e => { return { item: { key: e.internalId, text: e.name, secondaryText: e.username, imageUrl: e?.imageSource && e?.imagePath ? e?.imageSource + "" + e?.imagePath : undefined } } as ISuggestionModel<IPersonaProps> }) : []}
                                onGetMoreResults={() => {
                                    if (state.clients.items.length > 0 && !state.clients.isFetching) {
                                        const wrapper = new StringValue();
                                        wrapper.setValue(state.clients.items.at(state.clients.items.length - 1).internalId);
                                        clintsReq.setNextto(wrapper)
                                        getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                    var u = state.clients.items.findIndex(e => e.internalId == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedUserItems([state.clients.items.at(u)]))
                                    }

                                }}
                                inputProps={{ placeholder: t("client") }}

                                selectedItems={state.clients.selected.length > 0 ? state.clients.selected.map(e => { return { key: e.internalId, text: e.name, secondaryText: e.username, imageUrl: e?.imageSource && e?.imagePath ? e?.imageSource + "" + e?.imagePath : undefined } as IPersonaProps }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedUserItems([]))
                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetUsers())
                                    clintsReq.setSearch(undefined)
                                    clintsReq.setNextto(undefined)
                                    dispatch(setIsFilteredOwnersSet(false))
                                    getFilterPromise?.abort()
                                    getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
                                    return []


                                }}
                                onFilterChanged={onOwnersFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1000)

                                        }
                                    }]}
                            />



                        </Stack>
                        <Stack horizontalAlign="space-between" horizontal tokens={{ childrenGap: 20 }} >
                            <Label >{t("pair")}</Label>

                            <List
                                isPeoplePicker={true}
                                suggestionsHeaderText={t('pair')}
                                styles={{ root: { width: 268 } }}
                                isLoading={state.currencyPairs.items.length == 0 ? state.currencyPairs.isFetching : false}
                                isSearching={state.currencyPairs.items.length > 0 ? state.currencyPairs.isFetching : false}
                                moreSuggestionsAvailable={state.currencyPairs.hasMore && !state.currencyPairs.isFetching}
                                suggestions={state.currencyPairs.items.length > 0 ? state.currencyPairs.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } } as ISuggestionModel<IPersonaProps> }) : []}
                                onGetMoreResults={() => {
                                    if (state.currencyPairs.items.length > 0 && !state.currencyPairs.isFetching) {
                                        const wrapper = new StringValue();
                                        wrapper.setValue(state.currencyPairs.items.at(state.currencyPairs.items.length - 1).id);
                                        currecyPairsReq.setNextto(wrapper)
                                        getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                    var u = state.currencyPairs.items.findIndex(e => e.id == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedCurrencyPairItems([state.currencyPairs.items.at(u)]))
                                    }

                                }}
                                inputProps={{ placeholder: t("pair") }}

                                selectedItems={state.currencyPairs.selected.length > 0 ? state.currencyPairs.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } as IPersonaProps }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedCurrencyPairItems([]))

                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetCurrencyPairs())
                                    currecyPairsReq.setSearch(undefined)
                                    currecyPairsReq.setNextto(undefined)
                                    dispatch(setIsFilteredCurrencyPairsSet(false))
                                    getFilterPromise?.abort()
                                    getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                    return []
                                }}
                                onFilterChanged={onPairsFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1006)

                                        }
                                    }]}

                            />

                        </Stack>


                        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 20 }} >
                            <Label >{t("currency")}</Label>
                            <List
                                styles={{ root: { width: 268 } }}
                                inputProps={{ placeholder: t("currency") }}
                                suggestionsHeaderText={t('currencies')}
                                isLoading={state.currencies.items.length == 0 ? state.currencies.isFetching : false}
                                isSearching={state.currencies.items.length > 0 ? state.currencies.isFetching : false}
                                moreSuggestionsAvailable={state.currencies.hasMore && !state.currencies.isFetching}
                                suggestions={state.currencies.items.length > 0 ? state.currencies.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } } as ISuggestionModel<IPersonaProps> }) : []}
                                onGetMoreResults={() => {
                                    if (state.currencies.items.length > 0 && !state.currencies.isFetching) {
                                        const wrapper = new StringValue();
                                        wrapper.setValue(state.currencies.items.at(state.currencies.items.length - 1).id);
                                        currenciesReq.setNextto(wrapper)
                                        getFilterPromise = dispatch(getCurrencies({ body: currenciesReq, headers: getHeaders() }))
                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                    var u = state.currencies.items.findIndex(e => e.id == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedCurrencyItems([state.currencies.items.at(u)]))
                                    }
                                }}
                                isPeoplePicker={true}
                                selectedItems={state.currencies.selected.length > 0 ? state.currencies.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } as IPersonaProps }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedCurrencyItems([]))

                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetCurrencies())
                                    currenciesReq.setSearch(undefined)
                                    currenciesReq.setNextto(undefined)
                                    dispatch(setIsFilteredCurrenciesSet(false))
                                    getFilterPromise?.abort()
                                    getFilterPromise = dispatch(getCurrencies({ body: currenciesReq, headers: getHeaders() }))
                                    return []
                                }}
                                onFilterChanged={onCurrenciesFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1003)

                                        }
                                    }]}
                            />

                        </Stack>


                        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 20 }} >
                            <Label >{t("sender")}</Label>
                            <List
                                styles={{ root: { width: 268 } }}
                                inputProps={{ placeholder: t("sender") }}
                                isPeoplePicker={true}
                                suggestionsHeaderText={t('accounts')}
                                isLoading={state.fromAccount.items.length == 0 ? state.fromAccount.isFetching : false}
                                isSearching={state.fromAccount.items.length > 0 ? state.fromAccount.isFetching : false}
                                moreSuggestionsAvailable={state.fromAccount.hasMore && !state.fromAccount.isFetching}
                                suggestions={state.fromAccount.items.length > 0 ? state.fromAccount.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : []}
                                onGetMoreResults={() => {
                                    if (state.fromAccount.items.length > 0 && !state.fromAccount.isFetching) {
                                        const wrapper = new StringValue();
                                        wrapper.setValue(state.fromAccount.items.at(state.fromAccount.items.length - 1).internalId);
                                        fromAccountsReq.setNextto(wrapper)
                                        getFilterPromise = dispatch(getFromAccounts({ body: fromAccountsReq, headers: getHeaders() }))
                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                    var u = state.fromAccount.items.findIndex(e => e.internalId == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedFromAccountItems([state.fromAccount.items.at(u)]))
                                    }

                                }}

                                selectedItems={state.fromAccount.selected.length > 0 ? state.fromAccount.selected.map(e => { return { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } as IPersonaProps }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedFromAccountItems([]))
                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetFromAccountsSet())
                                    fromAccountsReq.setSearch(undefined)
                                    fromAccountsReq.setNextto(undefined)
                                    dispatch(setIsFilteredFromAccountSet(false))
                                    getFilterPromise?.abort()
                                    getFilterPromise = dispatch(getFromAccounts({ body: fromAccountsReq, headers: getHeaders() }))
                                    return []
                                }}
                                onFilterChanged={onFromAccountsFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1005);

                                        }
                                    }]}
                            />


                        </Stack>

                        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 20 }} >
                            <Label >{t("receiver")}</Label>
                            <List
                                styles={{ root: { width: 268 } }}
                                inputProps={{ placeholder: t("receiver") }}
                                isPeoplePicker={true}
                                suggestionsHeaderText={t('accounts')}
                                isLoading={state.toAccount.items.length == 0 ? state.toAccount.isFetching : false}
                                isSearching={state.toAccount.items.length > 0 ? state.toAccount.isFetching : false}
                                moreSuggestionsAvailable={state.toAccount.hasMore && !state.toAccount.isFetching}
                                suggestions={state.toAccount.items.length > 0 ? state.toAccount.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : []}
                                onGetMoreResults={() => {
                                    if (state.toAccount.items.length > 0 && !state.toAccount.isFetching) {
                                        const wrapper = new StringValue();
                                        wrapper.setValue(state.toAccount.items.at(state.toAccount.items.length - 1).internalId);
                                        toAccountsReq.setNextto(wrapper)
                                        getFilterPromise = dispatch(getToAccounts({ body: toAccountsReq, headers: getHeaders() }))
                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                    var u = state.toAccount.items.findIndex(e => e.internalId == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedToAccountItems([state.toAccount.items.at(u)]))
                                    }

                                }}

                                selectedItems={state.toAccount.selected.length > 0 ? state.toAccount.selected.map(e => { return { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } as IPersonaProps }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedToAccountItems([]))
                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetToAccountsSet())
                                    toAccountsReq.setSearch(undefined)
                                    toAccountsReq.setNextto(undefined)
                                    dispatch(setIsFilteredToAccountSet(false))
                                    getFilterPromise?.abort()
                                    getFilterPromise = dispatch(getToAccounts({ body: toAccountsReq, headers: getHeaders() }))
                                    return []
                                }}
                                onFilterChanged={onToAccountsFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1004);

                                        }
                                    }]}
                            />


                        </Stack>


                        <Stack horizontalAlign="space-between" horizontal tokens={{ childrenGap: 20 }} >
                            <Label>{t("from")}</Label>
                            <DatePicker

                                firstDayOfWeek={DayOfWeek.Sunday}
                                placeholder={t("from")}
                                value={state.fromFilterOption.value != "" ? moment(state.fromFilterOption.value, 'YYYY-MM-DD').toDate() : undefined}
                                styles={{ root: { width: 300 } }}
                                ariaLabel={t("from")}
                                formatDate={(e) => {
                                    return formatDate(e, 'YYYY-MM-DD')
                                }}
                                parseDateFromString={(date) => {
                                    return moment(date, 'YYYY-MM-DD').toDate();
                                }}
                                strings={defaultDatePickerStrings}
                                onSelectDate={(date: Date | null | undefined) => {
                                    if (date)
                                        dispatch(setFromFilterOption({ value: formatDate(date, 'YYYY-MM-DD'), text: t("from") + ":" + formatDate(date, 'YYYY-MM-DD') }))

                                }}

                            />

                        </Stack>
                        <Stack horizontalAlign="space-between" horizontal tokens={{ childrenGap: 20 }} >
                            <Label>{t("to")}</Label>
                            <DatePicker

                                firstDayOfWeek={DayOfWeek.Sunday}
                                placeholder={t("to")}
                                value={state.toFilterOption.value != "" ? moment(state.toFilterOption.value, 'YYYY-MM-DD').toDate() : undefined}
                                styles={{ root: { width: 300 } }}
                                ariaLabel={t("to")}
                                formatDate={(e) => {
                                    return formatDate(e, 'YYYY-MM-DD')
                                }}
                                parseDateFromString={(date) => {
                                    return moment(date, 'YYYY-MM-DD').toDate();
                                }}
                                strings={defaultDatePickerStrings}
                                onSelectDate={(date: Date | null | undefined) => {
                                    if (date)
                                        dispatch(setToFilterOption({ value: formatDate(date, 'YYYY-MM-DD'), text: t("to") + ":" + formatDate(date, 'YYYY-MM-DD') }))

                                }}

                            />

                        </Stack>
                        <DialogFooter>
                            <PrimaryButton text={t("search")} onClick={(e => {
                                search(state.searchText);
                                toggleIsCalloutVisible();
                            })} />
                            <DefaultButton text={t("clearFilter")} onClick={() => {
                                clearFilter();
                            }} />

                        </DialogFooter>
                    </Stack>
                </Callout>
            ) : null
            }

            <Stack.Item align="center"  >
                <Stack horizontal  >
                    <SearchField
                        inputProps={{
                            maxLength: 250,
                            placeholder: t("search"),
                        }}

                        onInputChange={(e) => {
                            dispatch(setSearchText(e));
                            return e;
                        }}
                        endButtons={[
                            { id: calloutTargetId, title: t("filter"), iconProps: { iconName: "filter" }, onClick: toggleIsCalloutVisible },
                            {
                                title: t("search"), checked: true, iconProps: { iconName: "search" }, onClick: () => {
                                    search(state.searchText);
                                    if (isCalloutVisible)
                                        toggleIsCalloutVisible();

                                }
                            }]}
                        onChange={(e) => {
                            const res = state.filters.filter(({ key: key1 }) => !e?.some(({ key: key2 }) => key1 === key2));
                            res?.forEach(e => {



                                if (e.key == 2) {
                                    dispatch(setSelectedUserItems([]))
                                    req.setClient(undefined)
                                }




                                if (e.key == 1) {
                                    dispatch(setStatusFilterOption({ key: 0, text: "" }))
                                    req.setStatus(undefined)
                                }

                                if (e.key == 3) {
                                    dispatch(setSelectedFromAccountItems([]))
                                    req.setFromaccount(undefined)
                                }
                                if (e.key == 4) {
                                    dispatch(setSelectedToAccountItems([]))
                                    req.setToaccount(undefined)
                                }
                                if (e.key == 5) {
                                    dispatch(setSelectedCurrencyItems([]))
                                    req.setCurrency(undefined)
                                }

                                if (e.key == 6) {
                                    dispatch(setFromFilterOption({ value: "", text: "" }))
                                    req.setFrom(undefined)
                                }
                                if (e.key == 7) {
                                    dispatch(setToFilterOption({ value: "", text: "" }))
                                    req.setTo(undefined)
                                }

                                if (e.key == 8) {
                                    dispatch(setSelectedCurrencyPairItems([]))
                                    req.setCurrencypair(undefined)
                                }

                            });
                        }}

                        onResolveSuggestions={() => { return [] }}
                        selectedItems={state.filters.map(e => { return { name: e.name, key: e.key } as ITag }) || []}
                        onSearch={(e) => {
                            search(state.searchText);
                            if (isCalloutVisible)
                                toggleIsCalloutVisible();
                        }}
                        onClear={(e) => {
                            dispatch(setSearchText(undefined))
                            if (state.set.isFilteredSet) {
                                search(undefined);
                            }
                            /*if (req.getSearch() && !state.managers.isFilteredSet) {
                                dispatch(resetRoles())
                                req.setNextto(undefined)
     
                                req.setSearch(undefined)
     
                                getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
                            }*/
                        }}
                        showIcon
                    />
                </Stack>
            </Stack.Item>



            <Table
                setKey="trades"
                items={state.set.items}
                columns={c}
                checkboxVisibility={props.isSelection ? CheckboxVisibility.always : CheckboxVisibility.onHover}
                compRef={ref}
                width={props.isSelection ? '80vw' : undefined}
                height={props.isSelection ? "60vh" : state.message == undefined ? "calc(100vh - 176px)" : "calc(100vh - 224px)"}
                onScroll={(e) => {
                    const bottom = e?.currentTarget?.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    if (bottom && !state.set.isFetching && state.set.hasMore) {
                        const wrapper = new StringValue();
                        wrapper.setValue(state.set.items.at(state.set.items.length - 11)?.id);
                        req.setNextto(wrapper)
                        getItemsPromise?.abort();
                        getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))

                    }
                }}
                selection={_selection}
                selectionMode={SelectionMode.single}
                disableSelectionZone={state.isChangeStateLoading}
                enableShimmer={state.set.items.length == 0 && state.set.isFetching}
                numberOfResultsOptions={[10, 50, 100]}
                selectedNumberOfResults={state.set.numberOfResults}
                onNumberOfResultsChange={(e) => {
                    dispatch(setNumberOfResults(e))
                    req.setNumofresults(e)
                }}
                isColumnSortingEnabled={state.set.selected.length == 0}

                constrainMode={ConstrainMode.unconstrained}
                layoutMode={props.isSelection ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.fixedColumns}
                onRowDidMount={(item?: any, index?: number) => {
                    //alert(index)
                    if (index == state.set.items.length - 11) { // last element renderd
                        const { current } = ref;
                        if (current) {
                            if (state.set.items.length > 0 && !state.set.isFetching && state.set.hasMore) {
                                if (current.scrollHeight == current.clientHeight) { // scroll not shown? get more data 
                                    const wrapper = new StringValue();
                                    wrapper.setValue(state.set.items.at(state.set.items.length - 11)?.id);
                                    req.setNextto(wrapper)
                                    getItemsPromise?.abort();
                                    getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))
                                }


                            }
                        }
                    }
                }}
            />
            {props.isSelection ? <DialogFooter>
                <PrimaryButton disabled={state.set.isFetching || state.set.selected.length == 0} text={state.set.isFetching ? undefined : t("select")} onClick={() => {
                    if (props.onItemSelected && state.set.selected.length > 0) {
                        props.onItemSelected(state.set.selected.at(0))
                    }
                }} >

                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.set.isFetching ? "block" : "none") } }} />

                </PrimaryButton>
                <DefaultButton disabled={state.set.isFetching} text={t("discard")} onClick={() => {
                    if (props.onCancel) {
                        props.onCancel()
                    }
                }} />
            </DialogFooter> : undefined}
        </Stack >



    );
}




